export {TranslateService, SupportedLangs} from './services/translate.service';
export {TranslateKey} from './types/translate-key';
